import { Component, OnInit, ViewContainerRef } from '@angular/core';
import { Router } from '@angular/router';
import { Toast, ToastsManager } from 'ng2-toastr/ng2-toastr';
import { environment } from '../../environments/environment';
import { AuthService } from '../service/auth.service';
import { CookiesService } from '../service/cookies.service';

@Component({
  selector: 'app-auth',
  templateUrl: './auth.component.html',
  styleUrls: ['./auth.component.css'],
})
export class AuthComponent implements OnInit {
  constructor(
    private router: Router,
    private auth: AuthService,
    vRef: ViewContainerRef,
    private toastr: ToastsManager,
    private cookies: CookiesService
  ) {
    //    console.log('[AuthComponent::ctor]');
    this.toastr.setRootViewContainerRef(vRef);
    this.router = router;
  }

  user;

  errorMsg = false;

  successMsg = false;

  msg = '';

  ngOnInit() {
    //    console.log('[AuthComponent::ngOnInit]');
    if (this.auth.getToken()) {
      //      console.log('[AuthComponent::ngOnInit] token exists, navigate to /home');
      this.router.navigate(['/home']);
    }

    //    console.log('[AuthComponent::ngOnInit] after initial check for token.');
    if (this.auth.getToken()) {
      //          console.log('[AuthComponent::ngOnInit] After second token check. Token still exists');

      if (this.auth.isLogin()) {
        //          console.log('[AuthComponent::ngOnInit] navigating /home');

        this.router.navigate(['/home']);
      } else {
        //          console.log('AuthComponent::ngOnInit(): we have a token, but not logged in. How is this possible? Why navigate to /auth?');
        localStorage.removeItem('token');
        this.router.navigate(['/auth']);
      }
    } else {
      //        console.log('AuthComponenet::ngOnInit(): no token. JWT cookie?');
      //
      // Check for a cookie. If we have a cookie (but no token), send the cookie to the auth endpoint to be validated and
      // return the token and user id.
      //
      const jwt = this.cookies.get('jwt');
      if (jwt !== '') {
        //            console.log(`[AuthComponent::ngOnInit] Found a JWT cookie, ${jwt}. Calling AuthService::doLogin()`);
        this.auth.doLogin(jwt).subscribe(
          (res) => {
            //                console.log('[AuthComponent::ngOnInit::AuthService::doLogin()] returned');

            localStorage.removeItem('token');

            if (res.status.toLowerCase() === 'success') {
              //
              // The login succeeded, so store the JWT as the token and the user id for the active user.
              // Then head over to the home page.
              //
              //                  console.log(`AuthComponent::ngOnInit(): called doLogin(). Success: set token, ${JSON.stringify(res.data)}`);
              localStorage.setItem('token', res.data.token);
              localStorage.setItem('userId', res.data.ralUserId);
              this.router.navigate(['/home']);
            } else {
              //
              // The login failed, so show the user a message and redirect them back to RAL Academy.
              //
              //                  console.log('AuthComponent::ngOnInit(): called doLogin(). Failure: set token. Redirect to login location?');
              this.failedLogin('Login failed');
            }
          },
          (err) => {
            //              console.error(`AuthComponent::ngOnInit()::doLogin() returned error. Why not clearing out token? err = ${err}`);
            this.msg = JSON.parse(err._body).message;
            this.failedLogin(this.msg);
          }
        );
      } else {
        //
        // We can get here if someone goes directly to the URL without a JWT.
        //
        //          console.warn('AuthComponent::ngOnInit(): no JWT. Calling AuthService::doLogout()');
        this.failedLogin(
          'Login failed due to missing credentials. You will be redirected back to the Residential Assisted Living Academy web site.'
        );
      }
    }
  }

  private failedLogin(message: string) {
    const timeout = 10000;
    this.toastr.error(message, 'Error', { toastLife: timeout });

    //
    // Make sure the user is fully logged out and that the info in their browser is all cleaned up.
    //
    this.auth.doLogout();

    //
    // Now that we have removed all of the data that tells the system we're logged in, redirect back to the RAL website
    // after a delay.
    //
    //    console.log('Setting timeout to redirect to logout URL');
    setTimeout(() => {
      //      console.log('Redirecting to logout URL');
      localStorage.clear();
      window.location.href = environment.logoutRedirectUrl;
    }, timeout);
  }
}



// WEBPACK FOOTER //
// ./src/app/auth/auth.component.ts